import React, { useEffect, useState } from 'react';
import { UserFlowModalState } from '../../UserFlow/UserFlowModal';
import { trackUsernameVerifiedEvent, trackUsernameVerifiedLoad } from '../../../../../utils/railsAnalytics';
import Modal from 'react-modal';
import Input from '../../TravellerContactInfo/FormFields/Input';
import '../LoginModals.css';
import { If } from 'react-extras';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const VerifiedIrctcUserName = (props: UserFlowModalState) => {
  const { closeModal, updateVerifiedUser, userStatus, showModal, allowClose, switchModal } = props;
  const [ showUserModal, setShowModal ] = useState<boolean>(showModal || false);

  useEffect(() => {
    trackUsernameVerifiedLoad();
  }, []);

  const closeUserModal = () => {
    setShowModal(false);
    closeModal();
  };

  const userNameVerified=() => {
    trackUsernameVerifiedEvent('remember_irctc_password_clicked');
    updateVerifiedUser(userStatus.userId);
  };

  const goToForgotPassWordPage=() => {
    trackUsernameVerifiedEvent('forgot_irctc_password_clicked');
    switchModal('forgotPassword', userStatus);
  };

  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeUserModal}
      className="loginModals"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <p className="makeFlex spaceBetween appendBottom40">
        <span className="modalTitle font26 latoBloack blackText">
            Username Verified!
        </span>
        <If condition={allowClose === true}>
          <span
            className="modalClose"
            onClick={closeUserModal}
          >
            X
          </span>
        </If>
      </p>
      <p className="vrtlSeperater" />
      <div className="makeFlex spaceBetween">
        <div className="leftPanel darkGreyText">
          <p className="font20 latoBold appendBottom10"> Do you remember your password? </p>
          <p className="font14 appendBottom50">
            Password is required by IRCTC for authentication after payment and <span className="redText">your booking might fail</span> if you don’t remember it.
          </p>
          <div className="makeFlex spaceBetween end appendBottom60">
            <Input
              labelName="IRCTC Username"
              errorMessage=""
              validationFail={false}
              type="text"
              additionalAttributes={{ placeholder: userStatus.userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg="Verified"
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly
              irctcUserId={userStatus.userId}
              switchModal={switchModal}
              onChangePage="verifyUsername"
            />
          </div>
          <p className="darkGreyText font16 latoBold" onClick={userNameVerified}>
            <a>Continue Booking</a>
          </p>
        </div>
        <div className="rightPanel darkGreyText">
          <p className="font20 latoBold  appendBottom10">Forgot Password?</p>
          <p className="latoBold font14 greenText appendBottom50">We can help you recover it</p>
          <p className="font14 appendBottom60">
            You can get a new password via SMS on your registered mobile number within 5-6 mins.
          </p>
          <button
            className="rightPanelBtn latoBold font12 deepskyBlueText textCenter"
            onClick={goToForgotPassWordPage}
          >
            Reset Password
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default VerifiedIrctcUserName;
